import axios from '@fs/zion-axios'
import CacheService from '@fs/zion-cache-service'

// cache badges for 5 min
const badgeCache = { storeName: 'chatBadges', lifetime: 5 * 60 * 1000 }
const badgeCacheService = new CacheService({ cache: badgeCache })

export function getGuestDetails(cisUserId) {
  return badgeCacheService.get(`/service/rootstech/rtc2021/orchestration/guests/${cisUserId}/badges`, cisUserId)
}

export function getGuestPreferences(cisUserId) {
  return axios
    .get(`/service/rootstech/rtc2021/orchestration/guests/${cisUserId}`)
    .then(({ data }) => data.guestSettings)
}

export function setGuestPreferences(cisUserId, preferences) {
  return axios.put(`/service/rootstech/rtc2021/orchestration/guests/${cisUserId}`, preferences)
}

export function registerGuest(cisUserId, guestName) {
  return axios.post(`/service/rootstech/rtc2021/orchestration/guests/${cisUserId}`, {
    guestName,
    showRelativesAtRootsTech: true,
  })
}

export function updateRegisteredGuest(cisUserId, guestName) {
  return axios.put(`/service/rootstech/rtc2021/orchestration/guests/${cisUserId}`, {
    guestName,
    showRelativesAtRootsTech: true,
  })
}

export function deleteGuest(cisUserId) {
  return axios.delete(`/service/rootstech/rtc2021/orchestration/guests/${cisUserId}`)
}
